import { css } from '@emotion/react'
import { memo, useCallback } from 'react'
import { openEmojiPicker } from '../../../app-state/modals/state.dialog'
import type { IUserImage } from '../../../mfcLogic/api/chatImages'
import IconButton from '../../Buttons/IconButton'
import EmoticonHappy from '../../Icons/EmoticonHappy'
import { getThemeSpacing } from '../../styles/appTheme'
import { palette } from '../../styles/colors'
import { COMPOSE_ICONS_SPACING } from '../../theme'

const buttonStyles = css({
    border: 0,
    padding: getThemeSpacing(COMPOSE_ICONS_SPACING),
})

interface ChatImagesButtonProps {
    onInsertEmoticon(key: string): void
    onInsertImage(imageData: IUserImage): void
    disabled?: boolean
    showSearch?: boolean
    fullWindow?: boolean
}

const ChatImagesButton = memo((props: ChatImagesButtonProps) => {
    const { disabled } = props
    const onTogglePopper = useCallback(() => {
        openEmojiPicker(props)
    }, [props])

    return (
        <IconButton
            css={buttonStyles}
            title="Browse Emojis/Images"
            onClick={onTogglePopper}
            data-testid="IconButton__EmojiImagePanel"
            disabled={disabled}
        >
            <EmoticonHappy
                {...(disabled ? { color: palette.inactiveGrey } : {})}
            />
        </IconButton>
    )
})

export default ChatImagesButton
